import { Interface } from '@ethersproject/abi'
import { useEthers } from './useEthers'
import { DELAY_ADDRESS, ERC20_ABI } from '../constants'
import { Pair } from '../model'
import { useChainCall } from './useChainCalls'
import { bigNumberFromHex } from '../utils'

const encoder = new Interface(ERC20_ABI)

export function useLiquidityApproval(pair?: Pair) {
  const { chainId, account } = useEthers()
  const data = useChainCall(
    !!account &&
      pair &&
      chainId &&
      pair.getChainId() === chainId && {
        address: pair.address,
        data: encoder.encodeFunctionData('allowance', [account, DELAY_ADDRESS[chainId]]),
      }
  )
  if (data) {
    return bigNumberFromHex(data)
  }
}
